import { render, staticRenderFns } from "./DashedBtn.vue?vue&type=template&id=30ab05fe&scoped=true"
import script from "./DashedBtn.vue?vue&type=script&lang=js"
export * from "./DashedBtn.vue?vue&type=script&lang=js"
import style0 from "./DashedBtn.vue?vue&type=style&index=0&id=30ab05fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30ab05fe",
  null
  
)

export default component.exports